import { render, staticRenderFns } from "./changeFranchise.vue?vue&type=template&id=c143aa56"
import script from "./changeFranchise.vue?vue&type=script&lang=js"
export * from "./changeFranchise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports